import { ILocation } from 'shared/types/location';
import { getGeoValue, TGeoValue, TJsonQuery } from '../../../packages/JsonQuery';
import { getUniqGeo } from './getUniqGeo';

export const addLocationToJsonQuery = (jsonQuery: TJsonQuery, { id }: ILocation): TGeoValue[] => {
  const geo = getGeoValue()(jsonQuery);

  if (!geo) {
    return [{ id, type: 'location' }];
  }

  const uniqLocations = getUniqGeo(geo, [{ id, type: 'location' }]);

  return geo.concat(uniqLocations);
};
